import { TableCell as Cell, TableRow } from '@mui/material'
import { ReactElement } from 'react'
import { Thumbnail } from 'src/ui-components'
import ValidationTag from '../../../Messages/ValidationTag'
import { Delete, Edit } from '@mui/icons-material'
import styled from 'styled-components'
import { defaultTheme } from 'src/theme'
import { show as showModal } from '@ebay/nice-modal-react'
import EditPartDrawer from '../../../Edit'
import { Part } from '../../../Common/interfaces'
import { observer } from 'mobx-react-lite'
import { useAddToListStore } from 'src/store/lists/AddToListStore'
import { useListsStore } from 'src/store/lists/ListsStore'

const Row = observer((props: Part): ReactElement => {
  const {
    seqno,
    lineCode,
    partNum,
    qty,
    description,
    comments,
    group,
    validationTag: validationTagEnum,
    visible,
    imgUrl,
  } = props
  const listStore = useListsStore()
  const addToListStore = useAddToListStore()
  const listId = listStore?.getSelectedListId()

  const handleRemove = (): void => {
    addToListStore.removePart(seqno)
  }

  const handleEdit = (): void => {
    const editablePart = {
      partId: seqno.toString(),
      ...props,
    }
    showModal(EditPartDrawer, {
      listId,
      group,
      part: editablePart,
      initialImgUrl: imgUrl,
      store: addToListStore,
    })
  }

  return (
    <TableRow {...(!visible && { style: { display: 'none' } })}>
      <TableCell>
        <ThumbnailWrapper>
          <Thumbnail urlOrBase64={imgUrl || ''} width={72} height={72} />
        </ThumbnailWrapper>
      </TableCell>
      <TableCell>{lineCode}</TableCell>
      <TableCell>
        <div>
          <span>{partNum}</span>
          <ValidationTag type={validationTagEnum} />
        </div>
      </TableCell>
      <TableCell>{description}</TableCell>
      <TableCell>{comments}</TableCell>
      <TableCell>{qty}</TableCell>
      <TableCell>{group}</TableCell>
      <CenteredTableCell>
        <Actions>
          <StyledEdit onClick={handleEdit} />
          <StyledDelete onClick={handleRemove} />
        </Actions>
      </CenteredTableCell>
    </TableRow>
  )
})

const TableCell = styled(Cell)`
  vertical-align: top;
`

const CenteredTableCell = styled(Cell)`
  vertical-align: inherit;
`

const Actions = styled.div`
  display: Flex;
  gap: 24px;
  color: ${defaultTheme.colors.columnBorder};
`

const StyledEdit = styled(Edit)`
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
`

const StyledDelete = styled(Delete)`
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
`

const ThumbnailWrapper = styled.div`
  font-size: 11px;
`

export default Row
